// extracted by mini-css-extract-plugin
module.exports = {"powerstream-cooperation-D":"D_powerstream-cooperation-D__VtHhu"};